import { getTranslationCatalog } from "./utils/_i18n.js";

export function addExploreUnife(trad) {
  var html =
    '<div class="explore-unife">' +
    "<div>" +
    "<span>" +
    trad["label_explore_unife"] +
    "</span> " +
    "<strong>unife</strong>" +
    "</div>" +
    '<svg width="28px" height="13px" viewBox="0 0 28 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="hero-1" transform="translate(-757.000000, -643.000000)" fill="#FFFFFF" fill-rule="nonzero"><g id="Expand_More"><path d="M782.590459,643.350514 L771.001337,653.12247 L759.412215,643.349338 C758.859682,642.883554 757.965886,642.883554 757.413353,643.349338 C756.862216,643.815122 756.862216,644.569767 757.413353,645.035551 L770.001267,655.650662 C770.552404,656.116446 771.447596,656.116446 771.998733,655.650662 L784.586647,645.035649 C785.137784,644.569865 785.137784,643.814044 784.586647,643.34826 C784.036904,642.88473 783.141597,642.88473 782.590459,643.350514 Z"></path></g></g></g></svg>' +
    "</div>";

  if ($("section.img-top .explore-unife").length <= 0) {
    $(
      "section.existing-content-tile.img-top, .tile.ctatile.show-explore.img-top"
    ).append(html);
    $(".explore-unife").on("touch click", function () {
      $("html,body").animate(
        {
          scrollTop: $(this).offset().top,
        },
        800
      );
    });
  }
}
